import { VENDOR_COMMANDS } from 'constants/vendor-commands';
import { ConversationStateType } from 'hooks/conversation/types';
import { vendorCommandAsync } from 'services/propel';
import { PropelAuthType } from 'services/propel/types';
import { DataDogLogger } from 'utils/dataDog';
import { CUSTOM_ACTION_NAMES } from 'utils/dataDog/constants';

/**
 * Get name and phone number information from the customer journey service
 * @param propelConversation Object containing the conversation ID and the propel access token.
 * @returns Name and phone number information
 */
export const getCjsDataAsync = async (
  propelConversation: PropelAuthType,
  conversationState: ConversationStateType,
) => {
  const { conversationId, mojoAccessToken: accessToken } = propelConversation;

  try {
    const { data: { profile: { name: { first = '' } = {}, phone = '' } = {} } = {} } =
      await vendorCommandAsync(
        conversationId,
        conversationState.twilio?.conversation.sid || '',
        VENDOR_COMMANDS.CARVANA_CUSTOMER_JOURNEY,
        accessToken,
      );
    return { firstName: first, phoneNumber: phone };
  } catch (error) {
    DataDogLogger.error(CUSTOM_ACTION_NAMES.CHAT_BE_COMMAND_FAILED, error);
  }
};
